import {
  PlaidAccountLinkToken,
  PlaidAccountLinkTokenForRelinkV2Error,
  PlaidAccountLinkTokenForRelinkV2Result,
  PlaidAccountLinkTokenForRelinkV2ResultTypenames,
  PlaidAccountLinkTokenForUpgradeError,
  PlaidAccountLinkTokenForUpgradeResult,
  PlaidAccountLinkTokenForUpgradeResultTypenames,
  PlaidAccountLinkTokenV2Error,
  PlaidAccountLinkTokenV2Result,
  PlaidAccountLinkTokenV2ResultTypenames,
} from '@varo/graphql-schema-types';

export const isPlaidAccountLinkTokenForUpgradeSuccess = (
  data: PlaidAccountLinkTokenForUpgradeResult | null | undefined,
): data is PlaidAccountLinkToken => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenForUpgradeResultTypenames.PlaidAccountLinkToken
  );
};

export const isPlaidAccountLinkTokenForUpgradeError = (
  data: PlaidAccountLinkTokenForUpgradeResult | null | undefined,
): data is PlaidAccountLinkTokenForUpgradeError => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenForUpgradeResultTypenames.PlaidAccountLinkTokenForUpgradeError
  );
};

export const isPlaidAccountLinkTokenV2Success = (
  data: PlaidAccountLinkTokenV2Result | null | undefined,
): data is PlaidAccountLinkToken => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenV2ResultTypenames.PlaidAccountLinkToken
  );
};

export const isPlaidAccountLinkTokenV2Error = (
  data: PlaidAccountLinkTokenV2Result | null | undefined,
): data is PlaidAccountLinkTokenV2Error => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenV2ResultTypenames.PlaidAccountLinkTokenV2Error
  );
};

export const isPlaidRelinkTokenError = (
  data: PlaidAccountLinkTokenForRelinkV2Result | null | undefined,
): data is PlaidAccountLinkTokenForRelinkV2Error => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenForRelinkV2ResultTypenames.PlaidAccountLinkTokenForRelinkV2Error
  );
};

export const isPlaidRelinkTokenSuccess = (
  data: PlaidAccountLinkTokenForRelinkV2Result | null | undefined,
): data is PlaidAccountLinkToken => {
  if (!data) {
    return false;
  }

  return (
    data.__typename ===
    PlaidAccountLinkTokenForRelinkV2ResultTypenames.PlaidAccountLinkToken
  );
};
